import { useState } from "react";
import localimgpath from "../../js/localimgpath";
import CategoriesBtnColor from "../../js/categoriesBtnData";
import CategoryDetailData from "../../js/categoryDetailData";
import {
  Animatespin,
  Navbar,
  MainHeading,
  Experience,
  Footer,
  CategoryDetailCom,
  CategoriesBtnCom,
} from "../../components/index";
import Icons from "../../assets/icon";
import Functions from "./index.function";
const CategoryDetail = () => {
  const {
    CategoriesTypesMain,
    isLoading,
    Main,
    MainisLoading,
    handleButtonClick,
    categoriesTtypesMainId,
    handleTalent,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Category Detail"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            <div className="grid grid-flow-col auto-cols-max gap-x-3 overflow-x-auto dashboard-scrollbar-cat px-2 py-4">
              {CategoriesTypesMain?.categories.map((value, index) => (
                <CategoriesBtnCom
                  key={index}
                  onClick={() => handleButtonClick(value?.id)}
                  btnTitle={value.title}
                  bgColor={
                    categoriesTtypesMainId === value?.id
                      ? CategoriesBtnColor[index % CategoriesBtnColor.length]
                          .activeBgColor
                      : CategoriesBtnColor[index % CategoriesBtnColor.length]
                          .bgColor
                  }
                  btnIcon={
                    value?.icon
                      ? `${localimgpath?.categoryIcons}/${value?.icon}`
                      : Icons.directorChairIcon
                  }
                  CateclassName={
                    "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                  }
                  fontClassname={"font-onestSemiBold"}
                  iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                  alt={value?.title}
                />
              ))}
            </div>
            {MainisLoading === true ? (
              <div className="py-2 sm:py-4">
                <Animatespin />
              </div>
            ) : (
              <div className="xs:py-2 sm:py-4 lg:pt-6">
                {Main?.talent?.length < 1 ? (
                  <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full">
                    Data not available
                  </p>
                ) : (
                  Main?.talent && (
                    <div className="xs:flex xs:justify-center xs:items-start xs:flex-wrap xs:gap-y-5 sm:grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-2 md:gap-4 lg:gap-5 2xl:gap-8">
                      {Main?.talent.map((value, index) => (
                        <div key={index}>
                          <CategoryDetailCom
                            onClick={() => handleTalent(value?.id)}
                            latestNewsthubmail={`${localimgpath?.talentThumbnail}/${value?.hero_image}`}
                            latestNewsTitle={value?.real_name}
                            alt={value?.stage_name}
                            position={value?.news_title}
                            bgcolor={
                              CategoryDetailData[
                                index % CategoryDetailData?.length
                              ].bgcolor
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            )}
          </>
        )}
      </div>
      <Experience />
      <Footer />
    </div>
  );
};

export default CategoryDetail;
